module.exports = __webpack_public_path__ + "static/media/0277_Small.309aa8e7.jpg";